export default __webpack_public_path__ + "static/media/Group3.964cd935.svg";